// extracted by mini-css-extract-plugin
module.exports = {"outer":"styles_outer__3g8Nm","mobileOuter":"styles_mobileOuter__Kggis","col":"styles_col__17FOU flex flex-column justify-start items-center"};